import gql from 'graphql-tag';

const GET_UNINSTALL_PROTECTION_CONFIG = gql`
  query GetUninstallProtectionConfig {
    getUninstallProtectionConfig
  }
`;

const GENERATE_PASSWORD = gql`
  query {
    generateUninstallProtectionPassword
  }
`;

export { GET_UNINSTALL_PROTECTION_CONFIG, GENERATE_PASSWORD };
